import styled, { css } from 'styled-components/macro';
import {
  ModelListDiv,
  ModelListTable,
  ModelListTd,
  ModelListTh
} from '../ModelListStyles';
import ToggleText from '../ToggleText';
import IconWithText from '../IconWithText';

export const ToggleTotal = styled(ToggleText)`
  height: 37px;
  background-color: ${props => props.theme.concrete};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  border-bottom: 1px solid ${props => props.theme.mercury};
  margin-bottom: 1rem;
  ${props =>
    !props.toggleState &&
    css`
      ~ table {
        display: none;
      }
      margin-bottom: 0;
      border-bottom: 1px solid transparent;
    `}

  @media screen and (min-width: 768px) {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  > div {
    > p {
      margin-top: 0.3rem;
    }
  }
`;

export const ToggleDetails = styled(ToggleText)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const CustomToggleDetails = styled(ToggleDetails)`
  > div {
    > svg {
      margin-bottom: 1px;
    }
  }
`;

export const CustomModelListDiv = styled(ModelListDiv)`
  /* padding: 0rem 0rem 3rem 0rem; */
  position: relative;
  padding: 0rem;
  min-height: unset;
  margin-bottom: 16px;
  ${props =>
    props.toggleState &&
    css`
      padding-bottom: 2.6rem;
      min-height: 100px;
      @media screen and (min-width: 1024px) {
        min-height: 156px;
      }
    `}

  @media screen and (min-width: 1024px) {
    table:last-of-type {
      margin-top: 10px;
    }
  }
`;

export const CustomModelListTable = styled(ModelListTable)`
  margin-bottom: unset;
`;

export const CustomModelListTh = styled(ModelListTh)`
  padding: 1.1rem 5px;
  width: ${props => props.customWidth};
`;
export const CustomModelListTd = styled(ModelListTd)`
  padding: 0.5rem 5px;
  padding-right: ${props => props.customPadding};

  /* last */
  ${props =>
    !props.noBorder &&
    css`
      padding-bottom: 1.2rem;
    `}
  ${props =>
    props.first &&
    css`
      padding-top: 1.2rem;
    `}
      
  ${props =>
    props.bold &&
    css`
      font-weight: 500;
      ${props => props.theme.fontStackHeader};
      > div {
        > p {
          font-weight: 500;
          ${props => props.theme.fontStackHeader};
        }
      }
    `}
      ${props =>
        props.extraBold &&
        css`
          font-weight: 600;
        `}
`;

export const FeeNotificationDiv = styled.div`
  margin-top: 21px;
  display: flex;
  justify-content: center;
  p {
    width: 218px;
    text-align: center;
    color: ${props => props.theme.dustierGray};
  }
`;

export const CustomIconWithText = styled(IconWithText)`
  > div {
    margin-top: -2px;
  }
  > p {
    ${props => props.theme.fontStackHeader};
    font-weight: 600;
    line-height: unset;
    font-size: 1.2rem;
  }
`;

export const EmptyTableDiv = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 22px;
`;

export const EmptyTableP = styled.p`
  color: ${props => props.theme.dustyGray};
  font-style: italic;
  font-weight: 300;
  /* font-size: 13px; */
`;
